import { render, staticRenderFns } from "./AppendChildOrders.vue?vue&type=template&id=7fbaf1fa"
import script from "./AppendChildOrders.vue?vue&type=script&lang=js"
export * from "./AppendChildOrders.vue?vue&type=script&lang=js"
import style0 from "./AppendChildOrders.vue?vue&type=style&index=0&id=7fbaf1fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports